export const isAdmin = (access) =>
  access.filter((admin) => admin.level === 2).length > 0;

export const isOwner = (access) =>
  access.filter((admin) => admin.level === 1).length > 0;
